<div class="flex items-center justify-center h-screen">
  <div class="text-center">
    <h1 class="text-9xl font-bold text-gray-800 dark:text-white">{{ errorCode }}</h1>
    <p class="mt-4 text-2xl font-medium text-gray-600 dark:text-gray-300">
      Oops! Something went wrong.
    </p>
    <p class="mt-2 text-gray-500 dark:text-gray-400">
      The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
    </p>
    <div class="mt-6">
      <a
        [routerLink]="'/events'"
        class="px-6 py-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300"
      >
        Go Back Home
      </a>
    </div>
  </div>
</div>
